import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from '../../../shared/components';
import { useAuth } from '../../auth/context/AuthContext';
import { PermissionScopes } from '../../auth/permissions';
import styles from '../Payments.module.css';

export const PaymentsLayout: React.FC = () => {
  const { t } = useTranslation(['payments', 'nav']);
  const { hasPermission } = useAuth();
  const canSettings = hasPermission(PermissionScopes.paymentsSettings);

  return (
    <div className={styles.page}>
      <Breadcrumb items={[{ label: t('title', { ns: 'payments' }), path: '/payments' }]} />
      <div className={styles.headerRow}>
        <div>
          <h2>{t('title')}</h2>
          <p className={styles.pageIntro}>{t('subtitle')}</p>
        </div>
      </div>
      <nav className={styles.tabBar} aria-label={t('sectionTabsLabel')}>
        <NavLink to="/payments" end className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}>
          {t('listTitle')}
        </NavLink>
        {canSettings ? (
          <>
            <NavLink to="/payments/settings" className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}>
              {t('settingsTitle')}
            </NavLink>
            <NavLink to="/payments/automations" className={({ isActive }) => `${styles.tab} ${isActive ? styles.tabActive : ''}`}>
              {t('automationsTitle')}
            </NavLink>
          </>
        ) : null}
      </nav>
      <Outlet />
    </div>
  );
};
